var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { Container } from "@/components/common/Container";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { InputMask } from "@/components/ui/InputMask";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from "@/components/ui/Select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import { useStepperControl } from "@/hooks/useStepperControl";
import { cn } from "@/lib/utils";
import { getGovPiExternalUrl } from "@/utils/govPiRedirect";
import { ResponseModel } from "@/models/ResponseModel";
import GatewayService from "@/services/api/GatewayService";
import { zodResolver } from "@hookform/resolvers/zod";
import { Share2Icon } from "@radix-ui/react-icons";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { AlertTriangle } from "lucide-react";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { z } from "zod";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Solicitar CNH Definitiva",
        path: "/",
        current: true,
    },
    {
        name: "Pagamento da taxa",
        path: "/",
    },
];
export function UserData() {
    var _this = this;
    var service = new GatewayService();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(""), error = _b[0], setError = _b[1];
    var _c = useState("cpf"), selectedTab = _c[0], setSelectedTab = _c[1];
    var _d = useState(false), isVerified = _d[0], setIsVerified = _d[1];
    var recaptchaRef = useRef(null);
    var formSchema = z.object({
        registerNumber: z
            .string()
            .optional()
            .refine(function (value) {
            if (selectedTab === "registerNumber") {
                var newValue = (value || "").replace(/[^0-9]/g, "");
                return newValue.length >= 9 && newValue.length <= 11;
            }
            else {
                return true;
            }
        }, {
            message: "Número de registro inválido. Ele deve ter entre 9 e 11 dígitos.",
        }),
        cpf: z
            .string()
            .optional()
            .refine(function (value) {
            if (selectedTab === "cpf") {
                var newValue = (value || "").replace(/[^0-9]/g, "");
                if (newValue.length === 11) {
                    return { message: "cpf errado" };
                }
            }
            else {
                return true;
            }
        }, { message: "CPF inválido" }),
        birthDate: z
            .string()
            .min(10, {
            message: "",
        })
            .max(10)
            .refine(function (value) {
            return value === moment(value, "DD/MM/YYYY").format("DD/MM/YYYY");
        }, { message: "Data de nascimento inválida" }),
        applicantName: z.string().min(9, {
            message: "",
        }),
        deliveryLocation: z
            .string()
            .min(1, { message: "Local de entrega deve ser informado" }),
    });
    var _e = useStepperControl(), handleNextStep = _e.handleNextStep, setServiceReturn = _e.setServiceReturn;
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            registerNumber: "",
            cpf: "",
            birthDate: "",
            applicantName: "",
            deliveryLocation: "",
        },
    });
    var tabChange = function (value) {
        setSelectedTab(value);
        handleRecaptchaReset();
    };
    var onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var data, ret, e_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue())) {
                        toast.error("Recaptcha não verificado");
                        return [2 /*return*/];
                    }
                    setError("");
                    setIsLoading(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    data = {
                        cpf: selectedTab === "cpf" ? values.cpf.replace(/[^0-9]/g, "") : "",
                        registro: selectedTab === "registerNumber"
                            ? values.registerNumber.replace(/[^0-9]/g, "")
                            : "",
                        nome: values.applicantName,
                        dataNascimento: moment(values.birthDate, "DD/MM/YYYY").format("YYYYMMDD"),
                        idUnidadeRetirada: values.deliveryLocation,
                    };
                    return [4 /*yield*/, service.solicitarPpd(data, (_b = recaptchaRef.current.getValue()) !== null && _b !== void 0 ? _b : "")];
                case 2:
                    ret = _f.sent();
                    if (ResponseModel.isOk(ret)) {
                        setServiceReturn(ret.data);
                        handleNextStep();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _f.sent();
                    if (isAxiosError(e_1)) {
                        setError(((_d = (_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || "Erro desconhecido");
                    }
                    else {
                        setError(((_e = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _e === void 0 ? void 0 : _e.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Erro desconhecido");
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    handleRecaptchaReset();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    function onError(values) {
        console.log("error", values);
    }
    function handleVerifyChange() {
        var _a;
        if (!!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue()) !== isVerified) {
            setIsVerified(function () { var _a; return !!((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.getValue()); });
        }
    }
    var _f = useQuery({
        queryKey: ["getLocaisRetirada"],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var ret;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, service.locaisRecebimento()];
                    case 1:
                        ret = _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/, (ret === null || ret === void 0 ? void 0 : ret.list) || []];
                }
            });
        }); },
        enabled: true,
        retry: 1,
        refetchOnWindowFocus: false,
    }), locaisRecebimento = _f.data, isFetchingLocaisRecebimento = _f.isFetching, errorLocaisRecebimento = _f.error;
    useEffect(function () {
        if (errorLocaisRecebimento) {
            toast.error("Erro ao carregar os locais de recebimento. Recarregue a página ou contate o suporte!");
            setIsLoading(false);
        }
    }, [errorLocaisRecebimento]);
    function handleRecaptchaReset() {
        var _a;
        setIsVerified(false);
        (_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
    }
    var goExternalService = function (event) {
        var url = getGovPiExternalUrl(process.env.PORTAL_URL, process.env.GOV_PI_URL);
        if (!url) {
            toast.error("Não é possível direcionar automaticamente. Acesse o site 'pidigital.pi.gov.br' e procure pelo serviço no Gov.pi Cidadão.");
            return;
        }
        var newWindow = window.open(url, "_blank");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        return false;
    };
    var isLoadingApp = isLoading || isFetchingLocaisRecebimento;
    var isDisabled = isLoadingApp || !isVerified || !!errorLocaisRecebimento;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Troca de CNH Permission\u00E1ria para Definitiva" }), _jsxs(ServiceInfo, { children: [_jsx(ServiceInfoItem, { title: "Poder\u00E3o solicitar a troca de CNH Permission\u00E1ria para CNH definitiva:", content: [
                            "Somente os condutores da base do Piauí;",
                            "Para CNH de outro Estado, o condutor deve comparecer à Sede do Detran-PI ou CIRETRAN para abertura do processo de transferência de prontuário e em seguida realizar coleta biométrica;",
                        ], listType: "unordered" }), _jsx(ServiceInfoItem, { title: "Instru\u00E7\u00F5es para a solicita\u00E7\u00E3o da CNH Definitiva:", content: [
                            'Preencha corretamente os dados abaixo, seguindo rigorosamente o que está impresso na CNH e confirme clicando em "Avançar";',
                            "Gere a taxa e em seguida efetue o pagamento na rede bancária ou via pix;",
                            "Sua Habilitação estará disponível aproximadamente no prazo de até 15 dias no local selecionado;",
                        ], listType: "ordered" })] }), _jsxs(Tabs, __assign({ defaultValue: "cpf", className: "w-full max-w-[856px]", onValueChange: tabChange }, { children: [_jsxs(TabsList, __assign({ className: cn("grid w-full grid-cols-2 px-5 bg-light-blue-500 text-black-600", "sm:max-w-[352px]") }, { children: [_jsx(TabsTrigger, __assign({ value: "registerNumber", disabled: isLoadingApp, className: "data-[state=active]:bg-dark-blue-500 data-[state=active]:text-light-gray" }, { children: "N\u00FAmero de Registro" })), _jsx(TabsTrigger, __assign({ value: "cpf", disabled: isLoadingApp, className: "data-[state=active]:bg-dark-blue-500 data-[state=active]:text-light-gray" }, { children: "N\u00FAmero de CPF" }))] })), _jsx(TabsContent, __assign({ value: "registerNumber" }, { children: _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit, onError), className: "w-full max-w-[856px] space-y-4 animate-fade-left" }, { children: [_jsxs("div", __assign({ className: "px-0 flex flex-wrap" }, { children: [_jsx(FormField, { control: form.control, name: "registerNumber", render: function (_a) {
                                                    var field = _a.field;
                                                    return (_jsxs(FormItem, __assign({ className: "w-full pr-0 md:pr-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Registro" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "000000000" }, field)) }), _jsx(FormDescription, { children: "O n\u00BA do Registro se encontra no verso da sua habilita\u00E7\u00E3o." }), _jsx(FormMessage, {})] })));
                                                } }), _jsx(FormField, { control: form.control, name: "birthDate", render: function (_a) {
                                                    var field = _a.field;
                                                    return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Data de Nascimento" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ placeholder: "dd/mm/aaaa", mask: "99/99/9999" }, field)) }), _jsx(FormDescription, { children: "Informe a data de nascimento no formato dd/mm/aaaa" }), _jsx(FormMessage, {})] })));
                                                } })] })), _jsx(FormField, { control: form.control, name: "applicantName", render: function (_a) {
                                            var field = _a.field;
                                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Nome do requerente" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Nome do requerente", maxLength: 44 }, field)) }), _jsx(FormDescription, { children: "Informe o seu nome exatamente como est\u00E1 impresso na sua CNH." }), _jsx(FormMessage, {})] }));
                                        } }), _jsx("div", __assign({ className: "w-full md:w-1/2" }, { children: _jsx(FormField, { control: form.control, name: "deliveryLocation", render: function (_a) {
                                                var field = _a.field;
                                                return (_jsxs(FormItem, __assign({ className: "w-full" }, { children: [_jsx(FormLabel, { children: "Local de entrega" }), _jsxs(Select, __assign({ onValueChange: field.onChange, defaultValue: field.value }, { children: [_jsx(FormControl, { children: _jsx(SelectTrigger, __assign({ disabled: isLoadingApp || !!errorLocaisRecebimento }, { children: _jsx(SelectValue, { placeholder: "Selecione o local de retirada" }) })) }), _jsx(SelectContent, { children: locaisRecebimento === null || locaisRecebimento === void 0 ? void 0 : locaisRecebimento.map(function (local) { return (_jsx(SelectItem, __assign({ value: "".concat(local.id) }, { children: "".concat(local.id, " - ").concat(local.descricao) }))); }) })] })), _jsx(FormMessage, {})] })));
                                            } }) })), _jsx("div", __assign({ className: "w-full" }, { children: _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6LfhvnksAAAAAKei6tW4nUvdqkKz9cU0cQnE_VQD", onChange: handleVerifyChange }) })), _jsxs("div", __assign({ className: "container px-0 flex flex-wrap space-y-2 md:space-y-0" }, { children: [_jsx("div", __assign({ className: "w-full pr-0 md:pr-6 md:w-1/2 relative" }, { children: _jsxs(Button, __assign({ onClick: goExternalService, className: "self-end w-full bg-etipi-green" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })) })), _jsx("div", __assign({ className: cn("w-full pl-0 md:pl-6 md:w-1/2 relative", isLoadingApp && "cursor-progress", errorLocaisRecebimento && "cursor-not-allowed") }, { children: _jsx(Button, __assign({ type: "submit", className: "self-end w-full bg-etipi-blue", disabled: isDisabled }, { children: isLoadingApp ? _jsx(LoadingSpinner, {}) : "Avançar" })) }))] }))] })) })) })), _jsx(TabsContent, __assign({ value: "cpf" }, { children: _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit, onError), className: "w-full max-w-[856px] space-y-4 animate-fade-left" }, { children: [_jsxs("div", __assign({ className: "container px-0 flex flex-wrap" }, { children: [_jsx(FormField, { control: form.control, name: "cpf", render: function (_a) {
                                                    var field = _a.field;
                                                    return (_jsxs(FormItem, __assign({ className: "w-full pr-0 md:pr-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "CPF" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ placeholder: "999.999.999-99", mask: "999.999.999-99" }, field)) }), _jsx(FormDescription, { children: "Informe o seu CPF, utilize apenas n\u00FAmeros." }), _jsx(FormMessage, {})] })));
                                                } }), _jsx(FormField, { control: form.control, name: "birthDate", render: function (_a) {
                                                    var field = _a.field;
                                                    return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Data de Nascimento" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ placeholder: "dd/mm/aaaa", mask: "99/99/9999" }, field)) }), _jsx(FormDescription, { children: "Informe a data de nascimento no formato dd/mm/aaaa" }), _jsx(FormMessage, {})] })));
                                                } })] })), _jsx(FormField, { control: form.control, name: "applicantName", render: function (_a) {
                                            var field = _a.field;
                                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Nome do requerente" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Nome do requerente", maxLength: 44 }, field)) }), _jsx(FormDescription, { children: "Informe o seu nome exatamente como est\u00E1 impresso na sua CNH." }), _jsx(FormMessage, {})] }));
                                        } }), _jsx("div", __assign({ className: "w-full md:w-1/2" }, { children: _jsx(FormField, { control: form.control, name: "deliveryLocation", render: function (_a) {
                                                var field = _a.field;
                                                return (_jsxs(FormItem, __assign({ className: "w-full" }, { children: [_jsx(FormLabel, { children: "Local de entrega" }), _jsxs(Select, __assign({ onValueChange: field.onChange, defaultValue: field.value }, { children: [_jsx(FormControl, { children: _jsx(SelectTrigger, __assign({ disabled: isLoadingApp || !!errorLocaisRecebimento }, { children: _jsx(SelectValue, { placeholder: "Selecione o local de retirada" }) })) }), _jsx(SelectContent, { children: locaisRecebimento === null || locaisRecebimento === void 0 ? void 0 : locaisRecebimento.map(function (local) { return (_jsx(SelectItem, __assign({ value: "".concat(local.id) }, { children: "".concat(local.id, " - ").concat(local.descricao) }))); }) })] })), _jsx(FormMessage, {})] })));
                                            } }) })), _jsx("div", __assign({ className: "w-full" }, { children: _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6LfhvnksAAAAAKei6tW4nUvdqkKz9cU0cQnE_VQD", onChange: handleVerifyChange }) })), _jsxs("div", __assign({ className: "container px-0 flex flex-wrap space-y-2 md:space-y-0" }, { children: [_jsx("div", __assign({ className: "w-full pr-0 md:pr-6 md:w-1/2 relative" }, { children: _jsxs(Button, __assign({ onClick: goExternalService, className: "self-end w-full bg-etipi-green" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })) })), _jsx("div", __assign({ className: cn("w-full pl-0 md:pl-6 md:w-1/2 relative", isLoadingApp && "cursor-progress", errorLocaisRecebimento && "cursor-not-allowed") }, { children: _jsx(Button, __assign({ type: "submit", className: "self-end w-full bg-etipi-blue", disabled: isDisabled }, { children: isLoadingApp ? _jsx(LoadingSpinner, {}) : "Avançar" })) }))] }))] })) })) }))] })), error && (_jsxs(Alert, __assign({ variant: "destructive", className: "w-full max-w-[856px] bg-red-100 border-0" }, { children: [_jsx(AlertTriangle, { className: "h-4 w-4" }), _jsx(AlertTitle, { children: "Aten\u00E7\u00E3o!" }), _jsx(AlertDescription, { children: error })] }))), _jsx(EvaluateServiceButton, {})] }));
}
